{
  "shared": {
    "combo": {
      "clear": "مسح {{label}}",
      "searching": "جارٍ البحث…",
      "noMatches": "لا توجد نتائج مطابقة",
      "nothing": "لا توجد خيارات",
      "loadFailed": "تعذّر تحميل الخيارات.",
      "unavailable": "غير متاح لك",
      "labelFailed": "تعذّر تحميل الاسم",
      "more": "توجد نتائج أخرى. اكتب لتضييق القائمة.",
      "results_zero": "لا توجد نتائج",
      "results_one": "نتيجة واحدة",
      "results_two": "نتيجتان",
      "results_few": "{{count}} نتائج",
      "results_many": "{{count}} نتيجة",
      "results_other": "{{count}} نتيجة",
      "found": {
        "suppliers_zero": "لا يوجد موردون مطابقون",
        "suppliers_one": "مورد واحد مطابق",
        "suppliers_two": "موردان مطابقان",
        "suppliers_few": "{{count}} موردين مطابقين",
        "suppliers_many": "{{count}} موردًا مطابقًا",
        "suppliers_other": "{{count}} مورد مطابق",
        "categories_zero": "لا توجد فئات مطابقة",
        "categories_one": "فئة واحدة مطابقة",
        "categories_two": "فئتان مطابقتان",
        "categories_few": "{{count}} فئات مطابقة",
        "categories_many": "{{count}} فئة مطابقة",
        "categories_other": "{{count}} فئة مطابقة",
        "nodes_zero": "لا توجد وحدات شراء مطابقة",
        "nodes_one": "وحدة شراء واحدة مطابقة",
        "nodes_two": "وحدتا شراء مطابقتان",
        "nodes_few": "{{count}} وحدات شراء مطابقة",
        "nodes_many": "{{count}} وحدة شراء مطابقة",
        "nodes_other": "{{count}} وحدة شراء مطابقة",
        "users_zero": "لا يوجد مستخدمون مطابقون",
        "users_one": "مستخدم واحد مطابق",
        "users_two": "مستخدمان مطابقان",
        "users_few": "{{count}} مستخدمين مطابقين",
        "users_many": "{{count}} مستخدمًا مطابقًا",
        "users_other": "{{count}} مستخدم مطابق",
        "agreements_zero": "لا توجد اتفاقيات مطابقة",
        "agreements_one": "اتفاقية واحدة مطابقة",
        "agreements_two": "اتفاقيتان مطابقتان",
        "agreements_few": "{{count}} اتفاقيات مطابقة",
        "agreements_many": "{{count}} اتفاقية مطابقة",
        "agreements_other": "{{count}} اتفاقية مطابقة"
      },
      "remove": "إزالة {{label}}",
      "overflow": "+{{n}}",
      "showAll": "عرض كل المختار",
      "showFewer": "عرض أقل",
      "added": "تمت إضافة {{label}}",
      "removed": "تمت إزالة {{label}}",
      "chosen": "مختار"
    }
  }
}
